import dynamic from 'next/dynamic'
import { StickyFooter } from 'components/StickyFooter'
import { SkillsYoullLearnSection } from '../components/variant_1/sections'
import { Hero } from '../components/variant_1/sections/Hero'

const BelowTheFold = dynamic(
  () =>
    import('../components/variant_1/BelowTheFold').then((m) => m.BelowTheFold),
  {
    ssr: false,
  },
)

export const Variant1PageContent = () => (
  <div>
    <Hero />
    <SkillsYoullLearnSection />
    <BelowTheFold />
    <StickyFooter />
  </div>
)
